import api from '../../api/'
const state = {
    all:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            name: ""
        }
        state.all.forEach(element => {           
            row = {
                name: element
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setrole(state, roles) {
        state.all = roles
    },
    addrole(state,role){
        state.all.push(role)
    }
}

const actions={
    async get_auth_roles({ commit },tokens){
        return api.role.get_auth_roles(tokens).then((response)=>{
            //commit('setrole', response.data.data)
            return response.data
            //return response.data.data
        })
    },
    async get_all_roles({ commit }){
        return api.role.get_all_roles().then((response)=>{
            commit('setrole', response.data.data)
            return response.data.data
        })
    },
    post_roles({commit},role){
        return api.role.post_roles(role).then((response)=>{
            commit('addrole', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    get_roles_by_entite({commit},entite_id){
        return api.role.get_roles_by_entite(entite_id).then((response)=>{
            commit('setrole', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    get_roles_by_role({commit},role){
        return api.role.get_roles_by_role(role).then((response)=>{
            commit('setrole', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
